module.exports = __webpack_public_path__ + "static/media/sick-leave.c97863f6.svg";